import React, { memo, useCallback } from 'react'
import { useTranslation } from '../../../../hooks/locale'
import { CategoryTabButton } from './styles'
import { getCategoryTabEventLabel } from './category-tabs'
import type { CategoryTab, CategoryTabOption } from './types'
import AnalyticsService from '../../../../services/analytics-service'
import { getCategory } from '../../../../utils/category-utils'
import { usePropertyDetailsContext } from '../../../../hooks/property-details'

interface CategoryTabItemProps {
    tab: CategoryTabOption
    isActive: boolean
    onTabChange: (key: CategoryTab) => void
}

const CategoryTabItem: React.FC<CategoryTabItemProps> = ({ tab, isActive, onTabChange }) => {
    const { t } = useTranslation()
    const { isComboListing } = usePropertyDetailsContext()

    const handleClick = useCallback(() => {
        AnalyticsService.trackClickEvent(getCategory(isComboListing), getCategoryTabEventLabel(tab.key))
        onTabChange(tab.key)
    }, [tab.key, onTabChange, isComboListing])

    return (
        <CategoryTabButton type="button" isActive={isActive} onClick={handleClick}>
            {t(tab.translationKey)}
        </CategoryTabButton>
    )
}

export default memo(CategoryTabItem)
